import React, { useCallback, useMemo, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DefaultProfile from "assets/svgs/default_profile.svg";
import {
  ProfileButton,
  ProfileDropdownButton,
  ProfilePopperView,
} from "./styles";
import { Divider, Popover } from "@mui/material";
import { Ptag } from "components/core";
import { USER_PROFILE_PAGES } from "constants";
import useUser from "hooks/useUser";
import { Link, useLocation } from "react-router-dom";

function ProfilePopper() {
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const { getLoggedInUserDetail } = useUser();
  const user = useMemo(() => {
    const user = getLoggedInUserDetail();

    return {
      name: user?.name || "",
      email: user?.email || "",
    };
  }, []);

  const isSelected = useCallback((path) => {
    if (location.pathname === path) {
      return true;
    }
  }, [location]);

  const open = Boolean(anchorEl);
  const id = open ? "profile-popper" : undefined;
  return (
    <div>
      <ProfileButton
        endIcon={<KeyboardArrowDownIcon />}
        startIcon={<img src={DefaultProfile} />}
        variant="text"
        onClick={handleClick}
      >
        {user.name}
      </ProfileButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        PaperProps={{
          sx: {
            boxShadow: "3px 3px 6px 0px #0000001A",
            border: "1px solid #D0D5DD",
            borderRadius: "6px",
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <ProfilePopperView>
          <header>
            <Ptag fontFamily="Montserrat">{user.name}</Ptag>
            <Ptag color="#8E8D91" fontWeight="400" fontSize="10px" marginTop="4px" fontFamily="Montserrat">
              {user.email}
            </Ptag>
          </header>
          <Divider
            style={{
              margin: "14px 0",
            }}
          />
          <section>
            {USER_PROFILE_PAGES.map(({ name, path, callback }) => (
              <Link
                to={path || "#"}
                key={name}
                onClick={() => setAnchorEl(null)}
                style={{
                  width: "100%",
                }}
              >
                <ProfileDropdownButton
                  isSelected={isSelected(path)}
                  variant="text"
                  onClick={callback}
                >
                  {name}
                </ProfileDropdownButton>
              </Link>
            ))}
          </section>
        </ProfilePopperView>
      </Popover>
    </div>
  );
}

export default ProfilePopper;
